import { SET_PORTFOLIO_FILTER, SET_PORTFOLIO_HELDAWAY_STATUS, SET_PORTFOLIO_LIST, SET_SELECTED_PORTFOLIO_OBJECT } from "../types/portfolioFilter";

export const storeSelectedPortfolio =
    (selectedPortfolio: { label: string, value: string }) => {
        return {
            type: SET_PORTFOLIO_FILTER,
            payload: selectedPortfolio,
        };
    };


export const storePortfolioList =
    (portfolioList: Array<{ label: string, value: string }>) => {
        return {
            type: SET_PORTFOLIO_LIST,
            payload: portfolioList,
        };
    };

export const setPortfolioHeldawayStatus =
    (isPortfolioHeldaway: boolean): { type: string; payload: boolean } => {
        return {
            type: SET_PORTFOLIO_HELDAWAY_STATUS,
            payload: isPortfolioHeldaway,
        };
    };

export const storeSelectedPortfolioObj =
    (selectedPortfolioObj: Record<string, any>) => {
        return {
            type: SET_SELECTED_PORTFOLIO_OBJECT,
            payload: selectedPortfolioObj,
        };
    };

export const storeBseTxnStatus = 
    (bseTxnStatus: boolean) => {
        return {
            type: "STORE_BSE_TXN_STATUS",
            payload: bseTxnStatus,
        };
    };